import request from '@/utils/request'

// Purchase Order List
export function getPoList(param) {
  let data = param
  return request({
    url: `/po/epms4000/getPoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Purchase Receipt
export function getPoReceive(param) {
  let data = param
  return request({
    url: `/po/epms4000/getPoReceive`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}